import { render, staticRenderFns } from "./SelectTasks.vue?vue&type=template&id=c240bffe"
import script from "./SelectTasks.vue?vue&type=script&lang=js"
export * from "./SelectTasks.vue?vue&type=script&lang=js"
import style0 from "./SelectTasks.vue?vue&type=style&index=0&id=c240bffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports